// src/pages/EntrepreneurshipEducationContent/AssessmentContentPage.js
import React, { useState, useEffect } from 'react';
import '../../styles/AssessmentContentPage.css'; 
import { FaNewspaper, FaSearch, FaLightbulb } from 'react-icons/fa'; 

const assessmentCategoriesData = {
    Local: ['Social Injustice', 'Economic Hell', 'Romantic Chaos', 'Ecosystem + ', 'Emergency ', 'Summative Assessment'],
    National: ['Social Injustice', 'Economic Hell', 'Romantic Chaos', 'Ecosystem +', 'Emergency', 'Summative Assessment'], 
    Continental: ['Trade Barriers', 'Regional Instability', 'Currency Issues', 'Infrastructure Gaps', 'Policy Harmonization', 'Summative (Continental)'],
    Global: ['Geopolitical Tensions', 'Global Supply Chains', 'International Law', 'Market Saturation', 'Cultural Adaptation', 'Summative (Global)']
};

function AssessmentContentPage({ currentScope, navigateToDashboardView }) {
  const [displayCategories, setDisplayCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(''); 

  useEffect(() => {
    const categoriesForThisScope = assessmentCategoriesData[currentScope] || assessmentCategoriesData['National'] || [];
    setDisplayCategories(categoriesForThisScope);

    if (categoriesForThisScope.length > 0) {
      // Only reset activeCategory if it's not already in the new list OR if the first item is different
      // This helps maintain the activeCategory if the scope changes but the category still exists.
      // However, for simplicity and to ensure a default is always set for a new scope,
      // we will set it to the first of the new list.
      setActiveCategory(categoriesForThisScope[0]);
    } else {
      setActiveCategory('No Categories');
    }
  }, [currentScope]); 

  const handleCategoryChange = (category) => {
    setActiveCategory(category); 
    console.log(`Viewing assessment category: ${category} for scope: ${currentScope}`);
  };

  return (
    <div className="assessment-content-page"> 
      <div className="breadcrumb bg-white p-3 rounded-lg shadow-sm border border-gray-200"> 
        <button 
            className="breadcrumb-link"
            onClick={() => navigateToDashboardView('functionalCardOverview', currentScope)} 
        >
          {currentScope} Menu 
        </button>
        <span>&gt;</span>
        <span className="active-breadcrumb">
          Assessments ({activeCategory})
        </span>
      </div>

      <div className="content-area">
        <div className="assessment-sidebar">
          <h3 className="sidebar-title">
            ASSESSMENTS 
          </h3>
          {displayCategories.length > 0 ? displayCategories.map((category) => (
            <button 
              key={category}
              className={`assessment-button ${activeCategory === category ? "active" : ""}`}
              onClick={() => handleCategoryChange(category)}
            >
              {category}
            </button>
          )) : <p className="p-3 text-gray-500">No assessment categories for this scope.</p>}
        </div>

        <div className="assessment-grid">
          {/* Card 1: TRENDING NEWS */}
          <div className="assessment-card">
            {/* Small dynamic heading */}
            {activeCategory && activeCategory !== 'No Categories' && (
              <p className="text-xs text-gray-500 mb-2 uppercase tracking-wider">{activeCategory}</p>
            )}
            <div className="card-icon">
              <FaNewspaper size={50} style={{ color: "#3f51b5" }} /> 
            </div>
            <h4 className="card-title">TRENDING NEWS</h4>
            <p className="card-description">
              Step 1: Getting trending news from Venting Room Users.
            </p>
          </div>

          {/* Card 2: PROBLEM IDENTIFICATION */}
          <div className="assessment-card">
            {/* Small dynamic heading */}
            {activeCategory && activeCategory !== 'No Categories' && (
              <p className="text-xs text-gray-500 mb-2 uppercase tracking-wider">{activeCategory}</p>
            )}
            <div className="card-icon">
              <FaSearch size={50} style={{ color: "#00bcd4" }} />
            </div>
            <h4 className="card-title">PROBLEM IDENTIFICATION</h4>
            <p className="card-description">
              Step 2: Identifying the main problem.
            </p>
          </div>

          {/* Card 3: SOLUTION */}
          <div className="assessment-card">
            {/* Small dynamic heading */}
            {activeCategory && activeCategory !== 'No Categories' && (
              <p className="text-xs text-gray-500 mb-2 uppercase tracking-wider">{activeCategory}</p>
            )}
            <div className="card-icon">
              <FaLightbulb size={50} style={{ color: "#4caf50" }} />
            </div>
            <h4 className="card-title">SOLUTION</h4>
            <p className="card-description">
              Step 3: Providing a solution to the problem.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssessmentContentPage;
